export default __webpack_public_path__ + "static/media/china_icon.04d6c01e.png";